import React from 'react';
import { FilterForm, useFilterFormActions } from './filter-form';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';

export const BooleanFilters = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems} />
);

function BooleanFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  if (column.id == 'content_type') {
    return (
      <>
        <FormControlLabel
          value="TV series"
          control={<Radio />}
          label="TV series"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Movies"
          control={<Radio />}
          label="Movies"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Book"
          control={<Radio />}
          label="Book"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Podcast"
          control={<Radio />}
          label="Podcast"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Game"
          control={<Radio />}
          label="Game"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Format"
          control={<Radio />}
          label="Format"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Story"
          control={<Radio />}
          label="Story"
          name="$eq"
          inputRef={form.register}
        />
          <FormControlLabel
          value="IP"
          control={<Radio />}
          label="IP"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value='Micro-Series'
          control={<Radio />}
          label="Micro-Series"
          name="$eq"
          inputRef={form.register}
        />
      </>
    );
  } else if (column.id == 'poster_path' || column.id == 'deal_count') {
    return (
      <>
        <FormControlLabel
          value="false"
          control={<Radio />}
          label="Available"
          name="$empty"
          inputRef={form.register}
        />
        <FormControlLabel
          value="true"
          control={<Radio />}
          label="Not available"
          name="$empty"
          inputRef={form.register}
        />
      </>
    );
  }
  // else {
  //     return (
  //       <>
  //         <FormControlLabel
  //           value="false"
  //           control={<Radio />}
  //           label="Contains a Deal Badge"
  //           name="$empty"
  //           inputRef={form.register}
  //         />
  //         <FormControlLabel
  //           value="true"
  //           control={<Radio />}
  //           label="Empty Deal Badge"
  //           name="$empty"
  //           inputRef={form.register}
  //         />
  //       </>
  //     );
}
